<h2 class="title">{{ "results.OVERALL_SCORE" | transloco }}</h2>

<div class="content">
  <qai-scores-list class="scores-list">
    @for (score of scoresArray; track score.label) {
      <qai-score
        [direction]="'column'"
        [size]="score.label === 'Overall score' ? 'large' : 'medium'"
        [kind]="score.kind"
        [value]="(score.value | number: '1.1-2') || ''"
        [max]="score.max"
        [label]="'results.OUT_OF' | transloco | uppercase"
        [description]="score.description"
      >
        <div qai-card-title qaiSlot="title">{{ ('results.' + score.labelKey) | transloco }}</div>

        @if (score.label === "Overall score" && isWeightAvg) {
          <button
            qai-link
            qaiSlot="link"
            (click)="handleOnClickHowIsCalculated()"
          >
            {{ "results.SCORE_CALCULATION_QUESTION" | transloco }}
          </button>
        }
      </qai-score>
    }
  </qai-scores-list>

  <dialog
    #dialog
    qai-dialog
    [heading]="'results.SCORE_CALCULATION_TITLE' | transloco"
    data-testId="scoreCalculationDialog"
  >
    {{ "results.OVERALL_SCORE_EXPLANATION" | transloco }}
    <br /><br />
    {{ "results.SCORE_CONFIG_NOTE" | transloco }}
  </dialog>

  <div class="feedback-cards">
    @if (scoreOverall?.Strengths?.feedback?.length) {
      <qai-result-card [title]="scoreOverall!.Strengths!.title || 'Strengths'">
        <ul>
          @for (item of scoreOverall!.Strengths!.feedback; track item) {
            <li>
              <b>{{ parseBold(item).boldText }}</b
              >{{ parseBold(item).restText }}
            </li>
          }
        </ul>
      </qai-result-card>
    }

    <qai-result-card
      [title]="scoreOverall?.Opportunities?.title || 'Opportunities'"
    >
      <ul>
        @for (item of scoreOverall?.Opportunities?.feedback ?? []; track item) {
          <li>
            <b>{{ parseBold(item).boldText }}</b
            >{{ parseBold(item).restText }}
          </li>
        }
      </ul>
    </qai-result-card>
  </div>
</div>
